import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        list: {},
        loading: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getList: (state) => state.list,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_LIST(state, list) {
            state.list = list;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        FETCH_LIST({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`Deleghe/paginated?${query}`)
                    .then((res) => {
                        commit("SET_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        CREATE({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.post(`Deleghe`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`Deleghe`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        UPDATE({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.update(`Deleghe`, params.id, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
    },
};
